// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconBarsMenu = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16">
            <path
                fill="currentColor"
                d="M17.0357143,13.9130435 L0.928125245,13.9130435 C0.433928694,13.9130435 0,14.3826082 0,14.9173916 C0,15.5304353 0.433928694,16 0.928125245,16 L17.0357143,16 C17.5660719,16 18,15.5304353 18,14.9956519 C18,14.3826082 17.5660719,13.9130435 17.0357143,13.9130435 Z M17.0357143,0 L0.928125245,0 C0.433928694,0 0,0.469564687 0,1.00434809 C0,1.53913017 0.433928694,2.08695652 0.928125245,2.08695652 L17.0357143,2.08695652 C17.5660719,2.08695652 18,1.61739184 18,1.08260843 C18,0.547826352 17.5660719,0 17.0357143,0 Z M17.0357143,6.95652174 L0.928125245,6.95652174 C0.433928694,6.95652174 0,7.42608709 0,8 C0,8.57391357 0.433928694,9.04347826 0.928125245,9.04347826 L17.0357143,9.04347826 C17.5660719,9.04347826 18,8.57391357 18,8 C18,7.42608643 17.5660719,6.95652174 17.0357143,6.95652174 Z"
            />
        </svg>
    );
};

export default IconBarsMenu;
